<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Termos</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Termos</div>
        </div>
      </div>

      <section class="appui-card" style="padding:22px 24px">
        <h2 class="appui-sec-title">Termos de uso / Privacidade</h2>
        <p class="appui-sec-sub">Texto exibido ao participante no app.</p>
        <ckeditor :editor="editor" v-model="terms" :config="editorConfig"></ckeditor>
        <div style="display:flex;justify-content:flex-end;border-top:1px solid #eff2f7;padding-top:16px;margin-top:18px">
          <button class="appui-btn appui-btn--primary" :disabled="saving" @click="save()">
            <span v-if="saving">Salvando...</span><span v-else>Salvar termos</span>
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: { ckeditor: CKEditor.component },
  name: 'app-terms',
  data () {
    return {
      terms: '',
      editor: ClassicEditor,
      editorConfig: { toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo'] },
      saving: false
    }
  },
  mounted () {
    const loader = this.$loading.show()
    services.getTerms()
      .then(res => { this.terms = res.data.data.terms || '' })
      .catch(() => errorMessage('Falha ao carregar termos.', 3000))
      .finally(() => loader.hide())
  },
  methods: {
    async save () {
      this.saving = true
      try {
        await services.updateTerms({ terms: this.terms })
        successMessage('Termos atualizados.', 2000)
      } catch (e) { errorMessage('Falha ao salvar termos.', 3000) } finally { this.saving = false }
    }
  }
}
</script>
